import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = authed
  const [company, setCompany] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
    } catch {
      setUser(false);
      setCompany(null);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    // fetch company too
    if (data.user?.company_id) {
      try {
        const { data: me } = await api.get("/auth/me");
        setCompany(me.company);
      } catch {}
    }
    return data;
  };

  const registerCompany = async (payload) => {
    const { data } = await api.post("/auth/register-company", payload);
    setUser(data.user);
    setCompany(data.company);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
    setCompany(null);
  };

  const refresh = fetchMe;

  return (
    <AuthContext.Provider value={{ user, company, login, registerCompany, logout, refresh, setCompany }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}

export { formatApiError };
